import rawList from "../data/words_alpha.txt?raw";

let WORDS: Set<string> | null = null;

function loadWords(): Set<string> {
if (WORDS) return WORDS;
const lines = rawList.split(/\r?\n/).map(s => s.trim().toUpperCase()).filter(Boolean);
WORDS = new Set(lines);
return WORDS;
}

/**
* Validates a word against the comprehensive English dictionary (466k+ words).
* Uses dwyl/english-words dataset (words_alpha.txt).
*/
export async function isValidWord(word: string): Promise<boolean> {
const set = loadWords();
return set.has(word.toUpperCase());
}